module.exports = __webpack_public_path__ + "static/media/400093_02.c0f5d751.png";